import { useState } from 'react';

interface MediaItem {
  seq: string;
  title: string;
  platform: string;
  tag: string;
  imageUrl: string;
}

const items: MediaItem[] = [
  {
    seq: 'media-01',
    title: '《星际征途》4K超清',
    platform: '香蕉视频',
    tag: '科幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20with%20futuristic%20space%20elements%20in%20warm%20coral%20and%20deep%20amber%20tones%2C%20representing%20sci-fi%20movie%20poster%2C%20minimalist%20geometric%20composition%2C%20editorial%20quality%2C%20dramatic%20lighting&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    seq: 'media-02',
    title: '《暗夜追踪》悬疑新剧',
    platform: '红桃视频',
    tag: '悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20mysterious%20urban%20scene%20with%20warm%20coral%20and%20shadow%20tones%2C%20representing%20crime%20drama%20series%2C%20minimalist%20noir%20composition%2C%20cinematic%20mood%2C%20editorial%20quality&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    seq: 'media-03',
    title: '《欢乐总动员》综艺',
    platform: '91视频',
    tag: '综艺',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20vibrant%20playful%20scene%20with%20warm%20coral%20and%20golden%20tones%2C%20representing%20variety%20show%20entertainment%2C%20minimalist%20geometric%20style%2C%20energetic%20composition%2C%20editorial%20quality&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    seq: 'media-04',
    title: '《大唐风云》古装巨制',
    platform: '蜜桃视频',
    tag: '古装',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20elegant%20classical%20scene%20with%20warm%20amber%20and%20terracotta%20tones%2C%20representing%20historical%20drama%2C%20minimalist%20traditional%20composition%2C%20editorial%20quality%2C%20soft%20gradient&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  const [imgErrors, setImgErrors] = useState<Record<string, boolean>>({});
  const handleImgError = (seq: string) => setImgErrors((prev) => ({ ...prev, [seq]: true }));

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              热播推荐
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选片单
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              当前各平台热播内容精选，点击跳转对应专题
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {items.map((item) => (
              <a
                key={item.seq}
                href="#carousel"
                className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-300 cursor-pointer no-underline"
              >
                <div className="aspect-video bg-background-200 overflow-hidden relative">
                  {!imgErrors[item.seq] ? (
                    <img
                      src={item.imageUrl}
                      alt={`${item.title} - 69视频精选片单`}
                      title={`69视频-${item.title}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      onError={() => handleImgError(item.seq)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-foreground-300">
                      <i className="ri-movie-2-line text-3xl"></i>
                    </div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500">
                    <i className="ri-tv-line mr-1"></i>
                    {item.platform}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}